// src/layouts/scenarios/create/data/useScenarioRoutesData.js
import { useEffect, useState } from "react";
import { fetchRoutes } from "../functions/fetchRoutes";

export default function useScenarioRoutesData(selectedKpi, preloadedRoutes = []) {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const monitoringType = selectedKpi?.monitoring?.type;

  useEffect(() => {
    if (monitoringType !== "routes") {
      setRoutes([]);
      setLoading(false);
      setError(null);
      return;
    }

    if (preloadedRoutes.length) {
      setRoutes(preloadedRoutes);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchRoutes();
        if (cancelled) return;

        setRoutes(data);
      } catch (err) {
        if (!cancelled) {
          console.error("useScenarioRoutesData error:", err);
          setError(err);
          setRoutes([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [monitoringType, preloadedRoutes]);

  return { routes, loading, error };
}
